import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { BRAND, GRAY, ACCENT, WHATSAPP } from "../colors";

export const ApproveAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const chatAppear = spring({ frame, fps, config: { damping: 14 } });
  const buttonPulse = frame >= 30 && frame < 55
    ? 1 + Math.sin(frame * 0.4) * 0.03
    : 1;
  const tapFrame = 55;
  const isTapping = frame >= tapFrame && frame <= tapFrame + 6;
  const postTap = frame > tapFrame + 6;
  const checkScale = spring({ frame: frame - tapFrame - 8, fps, config: { damping: 10, stiffness: 140 } });
  const sentBubble = spring({ frame: frame - tapFrame - 20, fps, config: { damping: 12 } });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: WHATSAPP.chatBg,
        justifyContent: "center",
        alignItems: "center",
        padding: 36,
      }}
    >
      <div
        style={{
          transform: `scale(${chatAppear})`,
          opacity: chatAppear,
          width: "100%",
          maxWidth: 480,
        }}
      >
        {/* Incoming message bubble */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "14px 14px 14px 4px",
            padding: "14px 18px",
            maxWidth: "85%",
            marginBottom: 10,
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 700, color: BRAND[600], marginBottom: 6 }}>
            📝 New Review
          </div>
          <div style={{ fontSize: 17, color: GRAY[700], lineHeight: 1.4 }}>
            <span style={{ color: "#F59E0B" }}>★★★★★</span> &quot;Best spa in Santa Monica!
            The facial was amazing.&quot;
          </div>
        </div>

        {/* Reply suggestion */}
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "14px 14px 14px 4px",
            padding: "14px 18px",
            maxWidth: "85%",
            marginBottom: 16,
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 700, color: BRAND[600], marginBottom: 6 }}>
            💬 Suggested Reply
          </div>
          <div style={{ fontSize: 17, color: GRAY[600], lineHeight: 1.4 }}>
            Thanks for visiting Coastal Spa in Santa Monica, Lisa! We&apos;re so glad you loved the facial. Book again anytime!
          </div>
        </div>

        {/* Approve button */}
        <div style={{ display: "flex", gap: 8 }}>
          <div
            style={{
              flex: 1,
              textAlign: "center",
              padding: "12px 0",
              borderRadius: 22,
              backgroundColor: ACCENT[500],
              color: "white",
              fontSize: 17,
              fontWeight: 700,
              transform: `scale(${isTapping ? 0.92 : buttonPulse})`,
              boxShadow: postTap
                ? `0 0 0 4px ${ACCENT[100]}`
                : "0 2px 8px rgba(34,197,94,0.3)",
            }}
          >
            {postTap ? (
              <span style={{ display: "inline-block", transform: `scale(${checkScale})` }}>
                ✓ Approved!
              </span>
            ) : (
              "✅ Approve"
            )}
          </div>
          <div
            style={{
              padding: "12px 20px",
              borderRadius: 22,
              backgroundColor: "white",
              color: GRAY[500],
              fontSize: 17,
              fontWeight: 600,
              opacity: postTap ? 0.4 : 1,
            }}
          >
            ✏️ Edit
          </div>
          <div
            style={{
              padding: "12px 20px",
              borderRadius: 22,
              backgroundColor: "white",
              color: GRAY[500],
              fontSize: 17,
              fontWeight: 600,
              opacity: postTap ? 0.4 : 1,
            }}
          >
            ⏭️ Skip
          </div>
        </div>

        {/* Sent confirmation bubble */}
        {frame > tapFrame + 20 && (
          <div
            style={{
              marginTop: 14,
              marginLeft: "auto",
              maxWidth: "75%",
              opacity: sentBubble,
              transform: `translateY(${interpolate(sentBubble, [0, 1], [10, 0])}px)`,
            }}
          >
            <div
              style={{
                backgroundColor: WHATSAPP.lightGreen,
                borderRadius: "14px 14px 4px 14px",
                padding: "10px 16px",
                fontSize: 16,
                color: GRAY[700],
              }}
            >
              ✅ Reply approved and posted to Google!
              <div style={{ fontSize: 12, color: GRAY[400], textAlign: "right", marginTop: 4 }}>
                9:42 AM ✓✓
              </div>
            </div>
          </div>
        )}
      </div>
    </AbsoluteFill>
  );
};
